/** This export is automatically generated */
export const gitHash = 'a9f865a19';
